// semanticTokens.ts

const semanticTokens = {
  colors: {
    // 🔹 Text colors

    //heading1
    textPrimary: {
      default: "#05103D", // Light mode
      _dark: "#F7FAFB", // Dark mode
    },
    //heading2
    textSecondary: {
      default: "#6A6B6C",
      _dark: "#BEBEBE",
    },
    //heading3
    textTertiary: {
      default: "#6A6B6C",
      _dark: "#F7FAFB",
    },
    //hoverColor
    textMuted: {
      default: "#DCECF5",
      _dark: "#78A9CB",
    },

    optionColor: {
      default: "white",
      _dark: "#53B5E0",
    },

    clearIndicatorColor: {
      default: "black",
      _dark: "white",
    },

    // 🔹 Icon colors
    iconColor1: {
      default: "#6A6B6C",
      _dark: "#BEBEBE",
    },
    iconColor2: {
      default: "#05103D",
      _dark: "#F7FAFB",
    },

    borderColor: {
      default: "#CDD5E0",
      _dark: "#6A6B6C",
    },

    // boxBorder: {
    //   default: "transparent", // Light mode → no border
    //   _dark: "#EEE" // Dark mode → border color
    // },

    EditableFilterContainerText: {
      default: "#6A6B6C",
      _dark: "#808080",
    },

    // 🔹 Background colors
    primaryBg: {
      default: "#F7FAFB",
      _dark: "#161618",
    },
    secondaryBg: {
      default: "#FFFFFF",
      _dark: "#202223",
    },
    surfaceBg: {
      default: "#F7FAFB",
      _dark: "#202223",
    },
    //common useCase
    accentBg: {
      default: "#FFFFFF",
      _dark: "#161618",
    },
    //headerBg
    mutedBg: {
      default: "#EEF1F2",
      _dark: "#202223",
    },
    overlayBg: {
      default: "#161618",
      _dark: "#FFFFFF",
    },
    tertiaryBg: {
      default: "#161618",
      _dark: "#F7FAFB",
    },
    optionbgColor: {
      default: "#05103D",
      _dark: "#1F2E36",
    },
    hoverbgColor: {
      default: "#dcecf5",
      _dark: "#6A6B6C",
    },
    hoverSecondarybgColor: {
      default: "#dcecf5",
      _dark: "#253136",
    },
    draggingbgColor: {
      default: "white",
      _dark: "#2A2C2E",
    },
    reportDetailBg: {
      default: "#FFFFFF",
      _dark: "#6A6B6C",
    },
    selectedRoutebgColor: {
      default: "#dcecf5",
      // _dark: "#253136"
      _dark: "#1F2E36",
    },
    schoolReviewbgColor: {
      default: "#F9F9F9",
      _dark: "#202223",
    },
    performancebgGradeA: {
      default: "#d8f3dc",
      _dark: "#213b33ff",
    },
    performancebgGradeB: {
      default: "#FFFEB7",
      _dark: "#29261E",
    },
    performancebgGradeC: {
      default: "#ffbdad",
      _dark: "#2B1C1E",
    },

    profileDetailbgColor: {
      default: "#FAFAFA",
      _dark: "#6A6B6C",
    },
    revieweeInfobgColor: {
      default: "#DEF0F7",
      _dark: "#1F2E36",
    },
    selectedReviewsbgColor: {
      default: "#E4E6E7",
      _dark: "#161618",
    },
    addedReviewsbgColor: {
      default: "#F1F4F5",
      _dark: "#202223",
    },
    revieweeSearchbgColor: {
      default: "#ECEEEF",
      _dark: "#202223",
    },
    toReviewbgColor: {
      default: "#d8f3dc",
      _dark: "#1F2825",
    },
    inProgressbgColor: {
      default: "#DCECF5",
      _dark: "#1F2E36",
    },
    permissionColor: {
      default: "#05103D",
      _dark: "#202223",
    },

    activebgColor: {
      default: "#d8f3dc",
      _dark: "#1F2825",
    },
    inactivebgColor: {
      default: "#ffbdad",
      _dark: "#2B1C1E",
    },

    // 🔹 Extra colors
    faintBlue: {
      default: "#F7FAFB",
      _dark: "#161618",
    },
    yellow: {
      default: "#FFDA69",
      _dark: "#FFD700",
    },
    //AI Button BG & Color
    AIButtonBg: {
      default: "#EEF8FC",
      _dark: "#2D3032",
    },
    AIButtonHover: {
      default: "#fff",
      _dark: "#2D3032",
    },
    AIBg: {
      default: "#FDFCFC",
      _dark: "#161618",
    },
    AIButtonPrimaryBg: {
      default: "#F2F5F7",
      _dark: "#2D3032",
    },
    AIButtonSecondaryBg: {
      default: "#F7FAFB",
      _dark: "#2D3032",
    },
    AIButtonMutedBg: {
      default: "#F7FAFB",
      _dark: "#253136",
    },
    AIButtonAccentBg: {
      default: "#EEF8FC",
      _dark: "#253136",
    },
    AIButtonColor: {
      default: "#53B5E0",
      _dark: "#F7FAFB",
    },
    AISearchBorderColor: {
      default: "#CDCFD8",
      _dark: "#2D3032",
    },
    TooltipBg: {
      default: "#161618",
      _dark: "#2D3032",
    },
    TooltipColor: {
      default: "#F7FAFB",
      _dark: "#F7FAFB",
    },
    ChatCircleLogo: {
      default: "#05130D",
      _dark: "#fff",
    },

    // Fixed colors (no dark mode required)
    // green.50: { default: "#d8f3dc" },
    // green.100: { default: "#6FCF97"},
    // red.50: { default:"#ffbdad" },
    // red.100: { default: "#EB5757" }
  },
};

export default semanticTokens;
